import { CatalystInsightCategory, CatalystSubcategories } from '@toggle/toggle';
import React from 'react';

import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { CatalystInsightPill } from '~/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import * as S from './InsightTypePill.styles';
import { constructMetadataSentence } from './utils';

export interface InsightTypePillProps {
  createdAt: string;
  updatedAt?: string;
  subCategory?: CatalystSubcategories;
  category: CatalystInsightCategory;
}

export const InsightTypePill = ({
  createdAt,
  updatedAt,
  subCategory,
  category,
}: InsightTypePillProps) => {
  const { insightId } = useCatalystDrawer();

  if (!insightId) {
    return null;
  }

  return (
    <S.Container>
      <CatalystInsightPill
        insightId={insightId}
        source={POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER}
        subCategory={subCategory}
        category={category}
      />
      <S.MetadataText>
        {constructMetadataSentence({
          createdAt,
          updatedAt,
        })}
      </S.MetadataText>
    </S.Container>
  );
};
